"use client";

import { DocsLayout } from "fumadocs-ui/layouts/docs";
import type { ReactNode } from "react";
import { baseOptions } from "@/app/layout.config";
import { source } from "@/lib/source";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";
import LoadingSpinner from "@/components/ui/loading";

export default function Layout({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuthRedirect();

  if (isLoading || !user) {
    return <LoadingSpinner />;
  }

  return (
    <DocsLayout
      tree={source.pageTree}
      {...baseOptions}
      themeSwitch={{
        enabled: false,
      }}
    >
      {children}
    </DocsLayout>
  );
}
